import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  input,
  OnInit,
  output,
  signal,
} from '@angular/core';
import { Button } from 'primeng/button';
import { Select, SelectChangeEvent } from 'primeng/select';
import { AsyncPipe, DatePipe, NgOptimizedImage } from '@angular/common';
import { Beneficjent } from '../../../shared/models/beneficjent';
import { MenuItem, MenuItemCommandEvent } from 'primeng/api';
import { APP_PATHS } from '../../config/app-paths';
import { Organizacja } from '../../../shared/models/organizacja';
import { SessionCounterService } from '../../services/session-counter.service';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import {
  ApplicationContext,
  ApplicationContextService,
} from '../../services/application-context.service';
import { DEFAULT_HOMEPAGE_URL } from '../../config/app-config';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-header',
  imports: [
    Button,
    NgOptimizedImage,
    AsyncPipe,
    DatePipe,
    Select,
    FormsModule,
    ReactiveFormsModule,
    TooltipModule,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent implements OnInit {
  public showUserControls = input<boolean | null>();
  public showSettings = input<boolean | null>();
  public user = input<Beneficjent | null>();
  public organization = input<Organizacja | null>();
  public sessionTime = input<Organizacja | null>();
  public isMobile = input<boolean>();
  public sidebarVisible = input<boolean>();
  public isApplicationContextSelectView = input<boolean>();
  public firstLogin = input<boolean>();
  protected readonly toogleSidebar = output<void>();
  protected readonly authService = inject(AuthService);
  protected readonly sessionCounterService = inject(SessionCounterService);
  readonly #applicationContextService = inject(ApplicationContextService);
  readonly #router = inject(Router);
  protected isUserAdmin = signal(this.authService.isUserAdmin());
  protected isCurrentContextAdmin = signal(
    this.#applicationContextService.isAdminContext(),
  );
  protected readonly contextMenuItem: MenuItem[] = [
    {
      label: 'Konto osobiste',
      id: ApplicationContext.BENEFICIARY,
      command: (event: MenuItemCommandEvent) =>
        this.#applicationContextService.switchToBeneficiary(),
    },
    ...(this.isUserAdmin()
      ? [
          {
            label: 'Konto administratora',
            id: ApplicationContext.ADMINISTRATOR,
            command: () => this.#applicationContextService.switchToAdmin(),
          },
        ]
      : []),
  ];
  readonly homePageUrl = input();
  readonly DEFAULT_HOMEPAGE_URL = DEFAULT_HOMEPAGE_URL;
  selectedOrganization: MenuItem | undefined | null = null;

  constructor() {
    this.updateSelectedOrganization();
  }

  ngOnInit(): void {
    this.#initializeContextMenuItem();
  }

  #initializeContextMenuItem(): void {
    this.user()?.organizacje?.forEach((value) => {
      this.contextMenuItem.push({
        label: value.nazwa!,
        id: value.id!.toString(),
        command: () =>
          this.#applicationContextService.switchToOrganization(value),
      });
    });
  }

  protected logOut(): void {
    this.sessionCounterService.endSession();
  }

  protected navigateToSettings(): void {
    if (this.organization() != null) {
      this.#router.navigate([APP_PATHS.organization.root]);
    } else {
      const url = `${APP_PATHS.userSettings.root}`;
      this.#router.navigate([url]);
    }
  }

  protected onChangeOrganization(e: SelectChangeEvent): void {
    e.value.command();
  }

  private updateSelectedOrganization(): void {
    effect(() => {
      if (this.#applicationContextService.isBeneficiaryContext()) {
        this.selectedOrganization = this.contextMenuItem.find(
          (el) => el.id == ApplicationContext.BENEFICIARY,
        );
      } else if (this.#applicationContextService.isAdminContext()) {
        this.selectedOrganization = this.contextMenuItem.find(
          (el) => el.id == ApplicationContext.ADMINISTRATOR,
        );
      } else {
        const org =
          this.#applicationContextService.getOrganizationFromContext();
        if (org) {
          this.selectedOrganization = this.contextMenuItem.find(
            (el) => el.id == org!.id,
          );
        } else {
          this.selectedOrganization = null;
        }
      }
    });
  }
}
